import React, { Fragment } from 'react';
import TeacherBannerBuy from '../../prelogin/src/components/TeacherBannerBuy';
import PlpvideoPlayer from '../../views/common/PlpvideoPlayer'

export default class TopBanner extends TeacherBannerBuy {

	render() {
		let country = this.props.country ? this.props.country : null;
		return (
			<section className={this.props.classes + " tchrhead"} >
				<div className="container">
					<div>
						<h1>{this.rb("sg.products.heading")}</h1>
						{/*<h1>{this.rb("sg.products.heading1")}</h1> */}
					</div>
					<div className="tchrdiv">
						<h2>{this.rb("sg.products.subheading")} <br />
							{this.rb("sg.products.subheading1")}</h2>
						<Fragment>
							{
								(country) ?
									<PlpvideoPlayer country={country} />
									:
									null
							}
						</Fragment>
					</div>
				</div>
			</section>
		);
	}
}


// WEBPACK FOOTER //
// ./src/views/others/TopBanner.js